export default __webpack_public_path__ + "assets/images/74ec2d5937ca21ff241d14ed8bc84e9d.svg";